/**
 * Created by Zxw on 2019/3/8.
 */

import Cookies from 'js-cookie';
import '../utils/aes.js';
import config from '../../config';
import Api from '../../sxui/api/base';
import appStore from '../store/index';
import AppStore from '../store';

const Auths = {
  router(to, from, next) {
    // 不需要登录的Router【支持/xxx/*写法】
    // if (config.auth.notLoginRouters.findIndex(item => item === to.path) !== -1) return next();
    if (config.auth.notLoginRouters.findIndex(item => {
      if (item.substr(item.length - 2, 2) === '/*' && to.path.indexOf(item.substr(0, item.length - 2)) === 0) {
        return true;
      } else {
        return item === to.path;
      }
    }) !== -1) return next();

    // 不需要登录的Router
    console.log('[-> AUTH] 需要验证登录状态', to.path);
    let token = Cookies.get(config.cookie.name);
    let source = to.query.source;
    let openid = to.query.openid;

    // 未登录
    if (!token || token.length < 10) {
      if (source && openid) {
        // 龙泉第三方系统登录
        this.lqLogin(source, openid, next);
      } else {
        this.sxLogin(to, from, next);
      }
    } else {
      if (source && openid) {
        // 龙泉第三方系统强制登录，清除旧用户
        this.logout(() => {
          console.log('[-> AUTH] 龙泉第三方系统强制登录，清除旧用户', to.path);
          this.lqLogin(source, openid, next);
        });
      } else {
        this.tokenLogin(token, next);
      }
    }
  },
  async lqLogin(source, openid, next) {
    let sourceUser = JSON.parse(Base64.decode(openid));
    console.log('[-> AUTH] 使用LQ第三方系统登录', source, openid, sourceUser);
    // 通用登录 API #古建国/2018-05-25#
    let { error, data } = await Api.gateway('/passport/UserAuthApi_login', {
      body: {
        account: sourceUser.mobile,
        accountType: 9,
        app: 'XWCZ',
        client: 'MANAGER',
        password: sourceUser.id_no || '666666' + Math.floor(100000000 + Math.random() * 10000000),
        platform: 'PC'
      }
    });
    // data = {"code":200,"message":"OK","data":{"token":"eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJqd3QiLCJzdWIiOiJ7XCJhY2NvdW50SWRcIjpcIjYwYTVjNzg2LTBmNWEtNDE3YS1hZDE3LWIxZjFhMzlkZGQ0YlwiLFwiYWNjb3VudFR5cGVcIjowLFwiYXBwXCI6XCJYV0NaXCIsXCJjbGllbnRcIjpcIk1BTkFHRVJcIixcInBsYXRmb3JtXCI6XCJQQ1wiLFwidXNlcklkXCI6XCJjZWU1N2JhMi0xMWNkLTRlZDktYTdkYy04YWE4N2QxODY2NGRcIn0iLCJleHAiOjE1NTIyOTAxMTgsImlzcyI6InN4ankifQ.FeQN6yeYnTBw1ysoJ57vJpLaQBRlFJMK5di6viTuRjo","refreshToken":"eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJqd3QiLCJzdWIiOiJleUpoWTJOdmRXNTBTV1FpT2lJMk1HRTFZemM0Tmkwd1pqVmhMVFF4TjJFdFlXUXhOeTFpTVdZeFlUTTVaR1JrTkdJaUxDSmhZMk52ZFc1MFZIbHdaU0k2TUN3aVlYQndJam9pV0ZkRFdpSXNJbU5zYVdWdWRDSTZJazFCVGtGSFJWSWlMQ0p3YkdGMFptOXliU0k2SWxCRElpd2lkWE5sY2tsa0lqb2lZMlZsTlRkaVlUSXRNVEZqWkMwMFpXUTVMV0UzWkdNdE9HRmhPRGRrTVRnMk5qUmtJbjA9IiwiZXhwIjoxNTUyMzM4MTE4LCJpc3MiOiJzeGp5In0.EPoTNzMjADmgiZQQ5Xa8bTGZqFUVFurtO3EmwG6cGy8","tokenExpiryDate":12000,"refreshTokenExpiryDate":60000},"errorData":"","success":true,"md5":"","alg":"SALT_MD5"};
    console.log(data);
    if (data && data.code === 200 && data.data && data.data.token) {
      console.log('[-> AUTH] 获取Token成功，写入Cookie，正常登录。');
      Cookies.set(config.cookie.name, data.data.token, {
        domain: config.cookie.domain
      });
      this.tokenLogin(data.data.token, next);
    } else {
      console.error('[-> AUTH] 获取Token失败，跳转至登录页面。');
      this.goLoginPage();
    }
  },
  sxLogin(to, from, next) {
    // Token存在，正常登录
    console.error('[-> AUTH] Token不存在，退出登录');
    this.goLoginPage();
  },
  async tokenLogin(token, next) {
    sessionStorage.removeItem('userInfo_3');

    // Token存在，进入验证用户信息流程
    console.log('[-> AUTH] Token存在', token);

    // userInfo存在并且格式正确
    if (appStore.state.user && typeof appStore.state.user === 'object') {
      console.log('[-> AUTH] userInfo存在', appStore.state.user);
      this.successAuthNext(next);
    } else {
      console.log('[-> AUTH] userInfo不存在', appStore.state.user);

      let userInfoBySessionStorage = sessionStorage.getItem('userInfo_3');
      if (userInfoBySessionStorage) {
        console.log('[-> AUTH] 从sessionStorage中获取到了userInfo', userInfoBySessionStorage);
        userInfoBySessionStorage = JSON.parse(userInfoBySessionStorage);
        appStore.commit('setUserInfo', userInfoBySessionStorage);
        this.successAuthNext(next);
      } else {
        // 查询当前登录人信息 #郑强/2018-01-23#
        let { error, data } = await Api.gateway('/platform/user_getCurrentUser');
        if (data.code === 200 && typeof data.data === 'object') {
          console.log('[-> AUTH] Ajax获取UserInfo成功，写入AppStore和SessionStorage，正常登录。');
          appStore.commit('setUserInfo', data.data);
          sessionStorage.setItem('userInfo_3', JSON.stringify(data.data));
          this.successAuthNext(next);
        } else {
          console.error('[-> AUTH] Ajax获取UserInfo失败，跳转至登录页面。');
          next('/admin/403?code=user_info_error');
        }
      }
    }
  },
  logout(callback) {
    // 退出登录
		appStore.commit('setUserInfo', null);

    // 清除sessionStorage中的roleCode? 什么地方调用过？
    sessionStorage.removeItem('roleCode');
    sessionStorage.removeItem('userInfo_3');

    // 清除Cookies name
    Cookies.remove(config.cookie.name, { domain: config.cookie.domain });
    Cookies.remove(config.cookie.name + '_refresh', { domain: config.cookie.domain });
    Cookies.remove(config.cookie.name + '_account_type', { domain: config.cookie.domain });
    Cookies.remove(config.cookie.name + '_' + config.name + '_role_code', { domain: config.cookie.domain });

    // 清除AuthCookieKey
    Cookies.remove(config.cookie.name + '_' + config.name + '_user_id', { domain: config.cookie.domain });
    Cookies.remove(config.cookie.name + '_' + config.name + '_role_code', { domain: config.cookie.domain });

    // 清除Storage
    if (!config.auth.notClearLocalStorage) localStorage.clear();
    if (!config.auth.notClearSessionStorage) sessionStorage.clear();

    if (callback) {
      callback();
    } else {
      this.goLoginPage();
    }
  },
  goLoginPage() {
    // 返回退出登录后的页面
    if (config.web.loginUrl) {
      return (window.location.href = config.web.loginUrl);
    } else {
      return (window.location.href = '/');
    }
  },
  async successAuthNext(next) {
    /* 需要认证的路由，并已经认证成功 */

    if (!appStore.state.setSystemLevel || !appStore.state.adminLevel) {
      console.log('[-> AUTH] 开始获取个人在报名系统中的权限信息');
      // 获取个人信息 #李茹钰/2019-03-15#
      let { error, data } = await Api.gateway('/bm/ISchoolApi_getMyMember');
      if (error || !data || data.code !== 200 || !data.data) {
        console.error('[-> AUTH] 获取个人信息失败，返回403页面', error, data);
        next('/admin/403?code=get_my_member_error');
      }
      data = data.data;
      console.log('[-> AUTH] 报名系统的权限信息成功', data);
      // 暂时写死，后面从config中读取["kinder" : "school"] todo
      let systemLevel = config.web.systemLevel || 'kinder';
      let adminLevel;
      // "userType": "integer 用户类型：0=教育局用户、1=街道用户、2=学校用户"
      if (data.userType === 0) {
        adminLevel = 'admin';
      } else if (systemLevel === 'school' && data.userType === 1) {
        // 只有幼儿园有街道端
        adminLevel = 'street';
      } else if (systemLevel === 'kinder' && data.userType === 2) {
        // 只有中小学有学校端
        adminLevel = 'school';
      } else {
        if (data.userType === 1 || data.userType === 2) {
          console.warn('[-> AUTH] 只有幼儿园有街道端、只有中小学有学校端！');
        }
        console.error('[-> AUTH] userType失败，返回403页面', data.userType, systemLevel);
        return next('/admin/403?code=userType_error');
      }
      appStore.commit('setSystemLevel', systemLevel);
      appStore.commit('setAdminLevel', adminLevel);
      appStore.commit('setSystemInfo', data);
      next();
    } else {
      next();
    }
  }
};

export default Auths;
